import React from "react";
import { FaEdit } from "react-icons/fa";
import DefaultButton from "./DefaultButton";

interface EditButtonProps {
    onClick: (e: React.MouseEvent) => void;
    className?: string;
    disabled?: boolean;
}

const EditButton = ({ onClick, className = "", disabled = false }: EditButtonProps) => {
    return (
        <DefaultButton
            className={`min-w-fit px-2 ${className}`}
            content={<FaEdit className="text-blue-500 cursor-pointer" />}
            onClick={(e: React.MouseEvent) => {
                e.stopPropagation();
                onClick(e);
            }}
            disabled={disabled}
        />
    );
};

export default EditButton;
